import type { GalleryItem } from '~/composables/types/event'

const getThumb = (image: GalleryItem) => {
  return image?.thumb || image?.cdn_url || image?.url
}

export const imageGetters = {
  getThumb,
}
